import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { IntegratorChildren } from '#src/types/index'

export const useIntegratorStore = defineStore('useIntegratorStore', () => {
  const children = ref<IntegratorChildren>([])
  const activeChildId = ref<string | null>(null)
  const iframeKeepAliveTimeouts = new Map<string, number>()
  const managedIframeIds = new Set<string>()
  const isDebug = ref<boolean>(false)

  const setChildren = (configChildren: IntegratorChildren) => {
    children.value = configChildren
  }

  const registerIframe = (id: string) => {
    managedIframeIds.add(id)
  }

  const unregisterIframe = (id: string) => {
    managedIframeIds.delete(id)
  }

  const setKeepAliveTimeout = (id: string, timeoutId: number) => {
    iframeKeepAliveTimeouts.set(id, timeoutId)
  }

  const clearKeepAliveTimeout = (id: string) => {
    const timeoutId = iframeKeepAliveTimeouts.get(id)

    if (timeoutId !== undefined) {
      clearTimeout(timeoutId)
      iframeKeepAliveTimeouts.delete(id)
    }
  }

  const removeAllIframes = () => {
    for (const timeoutId of iframeKeepAliveTimeouts.values()) {
      clearTimeout(timeoutId)
    }
    iframeKeepAliveTimeouts.clear()

    for (const id of managedIframeIds) {
      document.getElementById(id)?.remove()
    }
    managedIframeIds.clear()

    children.value.forEach((child) => {
      child.isLoaded = false
      child.isAwake = false
    })
  }

  return {
    isDebug,
    children,
    activeChildId,
    setChildren,
    registerIframe,
    unregisterIframe,
    setKeepAliveTimeout,
    clearKeepAliveTimeout,
    removeAllIframes,
  }
})
